<div class="site-filter-main w-100 h-100">
  <div class="row">
    <div class="col-12">
      <div class="header">
        <button type="button" class="close" (click)="closeDialog()">
          <span>
            <img src="assets/svg/ico-cross.svg" />
          </span>
        </button>
        <h2 class="modal-title text-center heading2"></h2>

        <br />
        <h1 class="text-center heading1 mt-5 mb-3 heading1">All Sites</h1>
      </div>
    </div>
  </div>

  <div class="row f-right w-100 switch-view mt-3 mb-5">
    <div class="col-6">
      <img
        (click)="setListView(false)"
        src="assets/svg/ico-square-menu.svg"
        [ngClass]="
          isListViewSelected ? 'grid-view-icon' : 'grid-view-icon active'
        "
      />
    </div>
    <div class="col-6">
      <img
        (click)="setListView(true)"
        src="assets/svg/ico-view-stacked.svg"
        [ngClass]="
          isListViewSelected ? 'list-view-icon active' : 'list-view-icon'
        "
      />
    </div>
  </div>
  <app-square-view
    [isListViewSelected]="isListViewSelected"
    [items]="items"
    (emitCloseDialog)="closeDialogByChildSqaureView($event)"
  ></app-square-view>
</div>
